import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'removeUnit',
})
export class RemoveUnitPipe implements PipeTransform {
  transform(value: string, print: boolean, anyValues: boolean): string {
    if (value.indexOf('(') < 0) {
      return value;
    }
    if (!print && anyValues) {
      return value;
    }
    const part1 = value.split('(')[0];
    const part2 = value.split(')')[1];
    return `${part1}${part2}`;
  }
}
